class Merger {
  mergeObjects(objects) {
    return Object.assign({}, ...objects);
  }
}
const merger = new Merger();
export { merger };